import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

// Configure nprogress
nprogress.configure({ showSpinner: false, speed: 500, trickleSpeed: 200 });

export default function PageLoader() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Start the progress bar
    nprogress.start();

    // Finish it after a tiny delay to simulate a premium load
    const timer = setTimeout(() => {
      nprogress.done();
    }, 400);

    return () => {
      clearTimeout(timer);
      nprogress.done();
    };
  }, [pathname]);

  return null;
}
